import styled from "@emotion/styled";

export const ContentWrapper = styled.div`
  padding: 10px 0px;
  cursor: pointer;
  &:first-of-type {
    padding-top: 0px;
  }
`;

export const TopWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Timestamp = styled.span<{ active: boolean }>`
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: ${(props) => (props.active ? "#2f8de4" : "#cdcdcd")};
`;

export const TimeIcon = styled.span<{ active: boolean }>`
  color: grey;
  margin: 0px 5px;
  font-size: 14px;
  color: ${(props) => (props.active ? "#2f8de4" : "#cdcdcd")};
`;

export const TextWrapper = styled.span<{ active: boolean }>`
  span {
    font-size: 12px !important;
    color: ${(props) => (props.active ? "#2f8de4" : "grey")} !important;
  }
`;
